module.exports = __webpack_public_path__ + "static/media/2.19ffb585.jpg";